export const lightTheme = {
    body:"#FCF6F4",
    text:"gray",
    fontFamily:"'Source Sans Pro', sans-serif",
    bodyRgba : "252, 246, 244",
    textRgba:"0,0,0",

}

export const DarkTheme = {
    body:"gray",
    text:"gray",
    fontFamily:"'Source Sans Pro', sans-serif",
    textRgba : "252, 246, 244",
    bodyRgba:"0,0,0",
}